import alertIcon from '../../../../../../../assets/icons/icon_alert_yellow_triangle.svg';
import styles from './UploadAlert.module.scss';
import { MdOpenInNew } from 'react-icons/md';
import { Button } from 'rsuite';
import { useHistory } from 'react-router-dom';

export const UploadAlert = () => {
  const history = useHistory();
  const goToAderenciaDePrecos = () => {
    history.push('/administrador/produtos/ISA/aderencia');
  };
  return (
    <div className={styles['segments-upload-alert']}>
      <div>
        <img src={alertIcon} alt="" className={styles['alert-icon']} />
      </div>
      <div>
        <p className={styles['bold-text']}>Aderência de Preços</p>
        <p className={styles['regular-text']}>
          Para utilizar segmentos personalizados no Aderência de Preços, é necessário fazer o upload de uma nova política de preços considerando os segmentos e
          produtos que serão analisados.
        </p>
        <p className={styles['regular-text']}>
          Após cadastrada a nova política de preços, <span className={styles['bold-text']}>os segmentos estarão prontos para uso no dia seguinte</span> ao
          clicar no filtro “segmentos personalizados”. Dessa forma, o painel responderá ao segmento selecionado.
        </p>
        <Button appearance="link" className={styles['upload-button']} onClick={goToAderenciaDePrecos}>
          <MdOpenInNew />
          Fazer upload da nova política de preços
        </Button>
      </div>
    </div>
  );
};
